import {CTA, styled} from '@volkswagen-onehub/components-core';
import React from 'react';
import useTrans from '../../../../hooks/use-trans';

const CompetitiveContainer = styled(CTA)`
  width: 100%;
  height: 100%;
  display: flex;
  row-gap: ${(props) => props.theme.size.dynamic0020};
  border-radius: ${({theme}) => theme.size.static150};
  border: none;
  box-shadow: 0 0 0 ${({theme}) => theme.size.border.active} ${({theme}) => theme.colors.border.hover};
  background: ${({theme}) => theme.colors.background.tertiary};
  padding: ${(props) => props.theme.size.grid001} ${(props) => props.theme.size.dynamic0020};
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    text-decoration: none;
    color: ${({theme}) => theme.colors.content.active};
  }

  &:focus-within {
    box-shadow: 0 0 0 ${({theme}) => theme.size.border.focus}
      ${({theme}) => theme.colors.focus.main};
    background: ${({theme}) => theme.colors.background.tertiary};
  }

  &:hover {
    transition: box-shadow 300ms ease, background 300ms ease;
    -webkit-transition: box-shadow 300ms ease, background 300ms ease;
    background: ${({theme}) => theme.colors.background.secondary};
    box-shadow: 0 0 0 ${({theme}) => theme.size.border.active} ${({theme}) => theme.colors.border.hover};
    &:focus-within {
      box-shadow: 0 0 0 ${({theme}) => theme.size.border.focus} ${({theme}) => theme.colors.focus.main};
    }
  }

`;

const CompetitiveLengthWrapper = () => {
  const {
    sections: {
      dimensions: {noVisual}
    }
  } = useTrans();

  const onClickDimension = () => {
    window.location.hash = "dimensions";
  };

  return (
    <CompetitiveContainer
      tag="button"
      emphasis="tertiary"
      onClick={onClickDimension}
    >{noVisual}</CompetitiveContainer>
  );
};

export default CompetitiveLengthWrapper;
